import { collection, getDocs, query, where } from "firebase/firestore";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import { db } from "../../../firebase";

const isDuplicatedEmail = async (authProviderEmail) => {
  /**
   * input:
   *  authProvider: email | phone
   * output: bool
   * description: checks if email exists
   */
  //these queries will change accroding to business rules
  try {
    const invitedAgentsRef = collection(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "agents"
    );
    const q = query(
      invitedAgentsRef,
      where("email", "==", authProviderEmail),
      where("is_deleted", "==", false)
    );

    const businessOwnersRef = collection(db, "users");
    const q2 = query(
      businessOwnersRef,
      //where("role","==","admin"),
      where("email", "==", authProviderEmail)
    );
    const businessSnapshot = await getDocs(q2);
    const agentSnapshot = await getDocs(q);
    return agentSnapshot.docs.length === 0
      ? businessSnapshot.docs.length === 0
        ? false
        : true
      : true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default isDuplicatedEmail;
